import Cookies from "js-cookie";

export const AddOrRemoveCookies = (
  operation,
  CookieName,
  DeleteAll = false
) => {
  if (DeleteAll) {
    localStorage.clear();
    sessionStorage.clear();
  }
  switch (operation) {
    case "add":
      Cookies.set(CookieName, {
        path: "/",
        sameSite: "strict",
        secure: window.top.location.protocol === "https:",
      });
      break;
    case "remove":
      Cookies.remove(CookieName, {
        path: "/",
        sameSite: "strict",
        secure: window.top.location.protocol === "https:",
      });
      break;
    default:
      break;
  }
};
